<template lang="pug">
#tabela-dados-fiscais-tributarios-pf
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )

    el-collapse(v-model='activeCollapseItem')
        el-collapse-item(
            :title='$t("mensagens.preAnaliseCredito.dadosFiscais.certidoesNegativasDeDebito")',
            name='0'
        )
            template(slot='title')
                | {{ $t('mensagens.preAnaliseCredito.dadosFiscais.MteCertidaoNegativaDeDebitos') }}
                i.mdi.mdi-minus-circle.ml-2(
                    v-if='!dados.mteCnd || !dados.mteCnd.processos',
                    style='font-size: 20px; color: #686868'
                )
            el-table(
                v-if='dados.mteCnd && dados.mteCnd.processos',
                :data='dados.mteCnd.processos',
                :default-sort='{ prop: "codigo", order: "ascending" }',
                style='width: 100%; max-height: 300px; overflow: auto',
                stripe
            )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.dataEmissao")',
                    align='left',
                    min-width='100px'
                )
                    template(slot-scope='{ row }')
                        | {{ mxFormatarData(dados.mteCnd.dataEmissao) }}
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.capitulacaoInfracao")',
                    prop='capitulacaoInfracao',
                    align='left',
                    min-width='200px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.categoriaInfracao")',
                    prop='categoriaInfracao',
                    align='left',
                    min-width='100px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.numeroDoProcesso")',
                    prop='numero',
                    align='left',
                    min-width='100px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.situacaoProcesso")',
                    prop='situacaoProcesso',
                    align='left',
                    min-width='100px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.situacaoDebitos")',
                    align='left',
                    min-width='100px'
                )
                    template(slot-scope='{ row }')
                        | {{ dados.mteCnd.situacaoDebito }}
            el-alert(
                v-else-if='!dados.mteCnd || !dados.mteCnd.processos',
                :title='$t("mensagens.preAnaliseCredito.dadosFiscais.naoHaRegistroParaCertidoesNegativasDebito")',
                type='warning',
                :closable='false'
            )
            .tabela-rodape-somatorio(v-if='dados.mteCnd')
                p(v-if='dados.mteCnd.processos') {{ dados.mteCnd.processos.length }} {{ $t('mensagens.preAnaliseCredito.dadosFiscais.certidoesDebito') }}

    el-collapse(v-model='activeCollapseItem')
        el-collapse-item(
            :title='$t("mensagens.preAnaliseCredito.dadosFiscais.listaDebitosPgfnDau")',
            name='1'
        )
            template(slot='title')
                | {{ $t('mensagens.preAnaliseCredito.dadosFiscais.listaDebitosPgfnDau') }}
                i.mdi.mdi-minus-circle.ml-2(
                    v-if='!dados.pessoaPgfnDau || !dados.pessoaPgfnDau.dividas',
                    style='font-size: 20px; color: #686868'
                )
            el-table(
                v-if='dados.pessoaPgfnDau && dados.pessoaPgfnDau.dividas',
                :data='dados.pessoaPgfnDau.dividas',
                :default-sort='{ prop: "valorInscricaoDevido", order: "ascending" }',
                style='width: 100%; max-height: 300px; overflow: auto',
                stripe
            )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.numeroInscricao")',
                    prop='inscricao',
                    align='left',
                    min-width='100px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.natureza")',
                    prop='natureza',
                    align='left',
                    min-width='200px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.valorTotalReais")',
                    :formatter='formatValueToBRLCurrency',
                    prop='valorInscricaoDevido',
                    align='left',
                    sortable,
                    min-width='200px'
                )
                el-table-column(
                    :label='$t("mensagens.preAnaliseCredito.dadosFiscais.valorTotalDebitosPgfnDauReais")',
                    align='left',
                    min-width='200px'
                )
                    template(slot-scope='{ row }')
                        | {{ formatValueToBRLCurrency(dados.pessoaPgfnDau.totalDividas) }}
            el-alert(
                v-else-if='!dados.pessoaPgfnDau || !dados.pessoaPgfnDau.dividas',
                :title='$t("mensagens.preAnaliseCredito.dadosFiscais.naoHaRegistrosListaDebitosPgfnDau")',
                type='warning',
                :closable='false'
            )
                .tabela-rodape-somatorio(
                    v-if='dados.pessoaPgfnDau && dados.pessoaPgfnDau.dividas'
                )
                    p(v-if='dados.pessoaPgfnDau.dividas') {{ dados.pessoaPgfnDau.dividas.length }} {{ $t('mensagens.preAnaliseCredito.dadosFiscais.inscricoes') }}
</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/modules/pre-analise-credito/components/BaseTableHeader';

export default {
    name: 'TabelaDadosFiscaisTributariosPf',

    components: {
        BaseTableHeader
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: true,
            default: 'Tabela'
        },
        iconeTituloTabela: {
            type: String,
            required: true,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data() {
        return {
            activeCollapseItem: ['0']
        };
    },

    methods: {
        formatCpfCnpjTableColumn(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },
        formatValueToBRLCurrency(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        }
    }
};
</script>

<style lang="scss">
#tabela-dados-fiscais-tributarios-pf {
    font-family: 'Roboto', 'sans serif' !important;
    border-radius: 5px 5px 0 0 !important;

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .el-table__body-wrapper {
            overflow-x: auto !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon > .el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 14px;
            font-weight: 500;
            line-height: 16.75px;

            th {
                max-width: 132px;
            }
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }
    }

    .table-patrimonio {
        height: 100%;
        width: 100%;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }
}
</style>
